/**
 * Raj Khausa Theme JS
 * Fully optimized for maximum speed - zero unnecessary delays
 */

window.formatMoney = (cents) => {
  if (typeof cents === 'string') return cents;
  const raw = (cents / 100).toFixed(2);
  // Add thousands comma: split on decimal, format integer part, rejoin
  const [intPart, decPart] = raw.split('.');
  const intWithComma = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const amount = `${intWithComma}.${decPart}`;
  const amountNoDecimals = intWithComma;
  const amountWithComma = amount.replace('.', ',');
  let format = window.moneyFormat || 'Rs. {{amount}}';
  return format
    .replace('{{amount_with_comma_separator}}', amountWithComma)
    .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimals)
    .replace('{{amount_no_decimals}}', String(Math.round(cents / 100)))
    .replace('{{amount}}', amount);
};

window.updateCartIcon = (count) => {
  const headerCount = document.getElementById('header-cart-count');
  if (headerCount) {
    const num = parseInt(count) || 0;
    headerCount.textContent = num;
    if (num > 0) {
      headerCount.classList.remove('hidden');
      headerCount.classList.add('flex');
    } else {
      headerCount.classList.add('hidden');
      headerCount.classList.remove('flex');
    }
  }
};

document.addEventListener('DOMContentLoaded', () => {
  initCartDrawer();
  initQuickAdd();
  initClickDelegation();
  initProductCardInteractions();
  initProductSliders();
  fixShopifyCookieBannerSEO();
});

// ─────────────────────────────────────────────
// PRODUCT IMAGE SLIDERS
// ─────────────────────────────────────────────
function initProductSliders() {
  document.body.addEventListener('click', (e) => {
    const prevBtn = e.target.closest('[data-slider-prev]');
    const nextBtn = e.target.closest('[data-slider-next]');
    
    if (!prevBtn && !nextBtn) return;
    
    e.preventDefault();
    e.stopPropagation();
    
    const slider = (prevBtn || nextBtn).closest('[data-product-slider]');
    if (!slider) return;
    
    // Set user-navigated flag so hover logic doesn't override manual navigation
    slider.setAttribute('data-user-navigated', 'true');
    
    const track = slider.querySelector('[data-slider-track]');
    const dots = slider.querySelectorAll('[data-dot-index]');
    const total = track.children.length;
    
    let currentIndex = parseInt(slider.dataset.currentIndex || 0);
    
    if (nextBtn) {
      currentIndex = (currentIndex + 1) % total;
    } else {
      currentIndex = (currentIndex - 1 + total) % total;
    }
    
    slider.dataset.currentIndex = currentIndex;
    track.style.transform = `translateX(-${currentIndex * 100}%)`;
    
    // Update dots
    dots.forEach((dot, idx) => {
      dot.setAttribute('data-active', (idx === currentIndex).toString());
    });
  });

  // Hover slide logic: slide to second image on hover
  document.body.addEventListener('mouseover', (e) => {
    const slider = e.target.closest('[data-product-slider]');
    if (!slider) return;
    
    // If the user has manually clicked next/prev during this hover session, don't auto-slide
    if (slider.getAttribute('data-user-navigated') === 'true') return;
    
    const track = slider.querySelector('[data-slider-track]');
    const dots = slider.querySelectorAll('[data-dot-index]');
    const total = track ? track.children.length : 0;
    
    if (total > 1 && slider.dataset.currentIndex === '0') {
      slider.dataset.currentIndex = '1';
      track.style.transform = 'translateX(-100%)';
      dots.forEach((dot, idx) => {
        dot.setAttribute('data-active', (idx === 1).toString());
      });
    }
  });

  // Re-enable hover and reset to first image when mouse leaves the slider container
  document.body.addEventListener('mouseout', (e) => {
    const slider = e.target.closest('[data-product-slider]');
    if (!slider) return;
    
    const related = e.relatedTarget;
    if (!related || !slider.contains(related)) {
      // Clear navigation flag and reset to first slide on leave
      slider.setAttribute('data-user-navigated', 'false');
      
      const track = slider.querySelector('[data-slider-track]');
      const dots = slider.querySelectorAll('[data-dot-index]');
      const total = track ? track.children.length : 0;
      
      if (total > 1) {
        slider.dataset.currentIndex = '0';
        if (track) track.style.transform = 'translateX(0%)';
        dots.forEach((dot, idx) => {
          dot.setAttribute('data-active', (idx === 0).toString());
        });
      }
    }
  });
}

// ─────────────────────────────────────────────
// PRODUCT CARD INTERACTIONS (Collection/Home)
// ─────────────────────────────────────────────
function initProductCardInteractions() {
  document.body.addEventListener('click', (e) => {
    // Buy Now button (for simple products)
    const buyNowBtn = e.target.closest('[data-buy-now-card]');
    if (buyNowBtn) {
      e.preventDefault();
      const variantId = buyNowBtn.dataset.variantId;
      if (!variantId) return;

      // Show loading/spinner state
      buyNowBtn.disabled = true;
      buyNowBtn.style.opacity = '0.8';
      const originalHtml = buyNowBtn.innerHTML;
      buyNowBtn.innerHTML = `
        <svg class="animate-spin h-5 w-5 text-[#FFED1B]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <span>Redirecting...</span>
      `;

      fetch('/cart/clear.js', { method: 'POST' })
        .then(() => {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
          });
        })
        .then(() => {
          // Submit a form targeting /cart with a submit button named "checkout".
          // This fires the standard DOM submit event that Razorpay Magic Checkout intercepts.
          const form = document.createElement('form');
          form.action = '/cart';
          form.method = 'POST';
          form.style.display = 'none';

          const btn = document.createElement('button');
          btn.type = 'submit';
          btn.name = 'checkout';
          btn.value = 'Checkout';

          form.appendChild(btn);
          document.body.appendChild(form);
          btn.click();
          document.body.removeChild(form);
        })
        .catch((err) => {
          console.error(err);
          // Fallback to permalink if AJAX fails
          window.location.href = `/cart/${variantId}:1`;
        });
      return;
    }

    // 1. "Add to Cart" button
    const addBtn = e.target.closest('[data-add-to-cart-simple]');
    if (addBtn) {
      e.preventDefault();
      const variantId = addBtn.dataset.variantId;
      if (!variantId) return;
      
      handleAddToCart(variantId, 1, addBtn);
      return;
    }

    // 2. Quantity Increment
    const incBtn = e.target.closest('[data-qty-inc]');
    if (incBtn) {
      const container = incBtn.closest('[data-cart-interaction-container]');
      const input = container?.querySelector('[data-qty-value]');
      const addBtnEl = container?.querySelector('[data-add-to-cart-simple]');
      const activePill = container?.closest('[data-product-card]')?.querySelector('.active-pill');
      
      if (!input || !addBtnEl) return;
      
      let qty = parseInt(input.value) || 1;
      const weight = parseInt(activePill?.dataset.weight || 0);
      const isB2B = activePill?.dataset.isB2b === 'true'; // Though product cards usually exclude B2B
      
      if (isB2B) {
        if (qty < 10) {
          qty++;
        } else {
          if (window.showToast) window.showToast('Maximum 10 boxes allowed for B2B orders');
          return;
        }
      } else if (weight > 0) {
        const maxQty = Math.max(1, Math.floor(20000 / weight));
        if (qty < maxQty) {
          qty++;
        } else {
          if (window.showToast) window.showToast('Maximum 21kg allowed per order');
          return;
        }
      } else {
        qty++;
      }
      
      updateCardUI(container, qty);
      debouncedCardUpdate(addBtnEl.dataset.variantId, qty, false, container);
      return;
    }

    // 3. Quantity Decrement
    const decBtn = e.target.closest('[data-qty-dec]');
    if (decBtn) {
      const container = decBtn.closest('[data-cart-interaction-container]');
      const input = container?.querySelector('[data-qty-value]');
      const addBtnEl = container?.querySelector('[data-add-to-cart-simple]');
      if (!input || !addBtnEl) return;
      let qty = parseInt(input.value) || 1;
      if (qty > 0) qty--;
      updateCardUI(container, qty);
      debouncedCardUpdate(addBtnEl.dataset.variantId, qty, false, container);
      return;
    }

    // 4. Variant Pill Click
    const pill = e.target.closest('[data-variant-pill]');
    if (pill) {
      e.preventDefault();
      const card = pill.closest('[data-product-card]');
      if (!card) return;

      const variantId = pill.dataset.variantId;
      const price = parseInt(pill.dataset.price);
      const comparePrice = parseInt(pill.dataset.comparePrice);
      const packCount = parseInt(pill.dataset.packCount);

      // 1. Update Price Elements
      const priceEl = card.querySelector('[data-card-price]');
      if (priceEl) priceEl.innerHTML = window.formatMoney(price);

      const comparePriceEl = card.querySelector('[data-card-compare-price]');
      const discountEl = card.querySelector('[data-card-discount]');
      if (comparePriceEl && comparePrice > price) {
        comparePriceEl.innerHTML = window.formatMoney(comparePrice);
        comparePriceEl.classList.remove('hidden');
        if (discountEl) {
          const discountPct = Math.round(((comparePrice - price) * 100) / comparePrice);
          discountEl.textContent = `${discountPct}% off`;
          discountEl.classList.remove('hidden');
        }
      } else {
        if (comparePriceEl) comparePriceEl.classList.add('hidden');
        if (discountEl) discountEl.classList.add('hidden');
      }

      // 2. Update Per Pcs Info
      const perPcsWrapper = card.querySelector('[data-card-per-pcs-wrapper]');
      const perPcsEl = card.querySelector('[data-card-per-pcs]');
      if (perPcsWrapper && perPcsEl) {
        if (packCount > 1) {
          perPcsEl.textContent = ` / Per pcs / Rs. ${((price / packCount) / 100).toFixed(2)}`;
          perPcsWrapper.classList.remove('hidden');
          perPcsWrapper.classList.add('inline');
        } else {
          perPcsWrapper.classList.add('hidden');
          perPcsWrapper.classList.remove('block');
        }
      }

      // 3. Update Add to Cart Button
      const addBtn = card.querySelector('[data-add-to-cart-simple]');
      const cartInteractionContainer = card.querySelector('[data-cart-interaction-container]');
      if (addBtn && cartInteractionContainer) {
        addBtn.dataset.variantId = variantId;
        const cartQty = parseInt(pill.dataset.cartQty || 0);
        updateCardUI(cartInteractionContainer, cartQty);
      }

      // 4. Update Active State of Pills
      const pills = card.querySelectorAll('[data-variant-pill]');
      pills.forEach(p => {
        if (p === pill) {
          p.classList.add('border-2', 'border-[#000828]', 'font-bold', 'active-pill');
          p.classList.remove('border', 'border-gray-300', 'font-normal', 'hover:border-2', 'hover:border-[#000828]');
        } else {
          p.classList.remove('border-2', 'border-[#000828]', 'font-bold', 'active-pill');
          p.classList.add('border', 'border-gray-300', 'font-normal', 'hover:border-2', 'hover:border-[#000828]');
        }
      });
      return;
    }
  });

  document.body.addEventListener('input', (e) => {
    if (e.target.matches('[data-qty-value]')) {
      const container = e.target.closest('[data-cart-interaction-container]');
      const addBtnEl = container?.querySelector('[data-add-to-cart-simple]');
      if (!container || !addBtnEl) return;
      let qty = parseInt(e.target.value);
      if (!isNaN(qty)) {
        const activePill = container.closest('[data-product-card]')?.querySelector('.active-pill');
        const weight = parseInt(activePill?.dataset.weight || 0);
        const isB2B = activePill?.dataset.isB2b === 'true';
        if (isB2B) {
          if (qty > 10) {
            qty = 10;
            e.target.value = 10;
            if (window.showToast) window.showToast('Maximum 10 boxes allowed for B2B orders');
          }
        } else if (weight > 0) {
          const maxQty = Math.max(1, Math.floor(20000 / weight));
          if (qty > maxQty) {
            qty = maxQty;
            e.target.value = maxQty;
            if (window.showToast) window.showToast('Maximum 21kg allowed per order');
          }
        }
        debouncedCardUpdate(addBtnEl.dataset.variantId, qty, false, container);
        syncPillQty(container, addBtnEl.dataset.variantId, qty);
      }
    }
  });
}

function syncPillQty(container, variantId, qty) {
  const card = container.closest('[data-product-card]');
  if (!card) return;
  const pill = card.querySelector(`[data-variant-pill][data-variant-id="${variantId}"]`);
  if (pill) pill.dataset.cartQty = qty;
}

function updateCardUI(container, qty) {
  const addBtn = container.querySelector('[data-add-to-cart-simple]');
  const qtySelector = container.querySelector('[data-quantity-selector]');
  const qtyInput = container.querySelector('[data-qty-value]');

  if (qty > 0) {
    if (addBtn) {
      addBtn.classList.add('opacity-0', 'pointer-events-none');
    }
    if (qtySelector) {
      qtySelector.classList.remove('opacity-0', 'pointer-events-none', 'translate-y-2');
      qtySelector.classList.add('opacity-100');
    }
    if (qtyInput) qtyInput.value = qty;
  } else {
    if (addBtn) {
      addBtn.classList.remove('opacity-0', 'pointer-events-none');
    }
    if (qtySelector) {
      qtySelector.classList.add('opacity-0', 'pointer-events-none', 'translate-y-2');
      qtySelector.classList.remove('opacity-100');
    }
    if (qtyInput) qtyInput.value = 1;
  }

  // Sync pill data even when UI updates
  if (addBtn) {
    syncPillQty(container, addBtn.dataset.variantId, qty);
  }
}

// Debounce only for qty changes (not initial add)
let cardUpdateTimeouts = {};

function debouncedCardUpdate(variantId, qty, isNew, container) {
  clearTimeout(cardUpdateTimeouts[variantId]);
  cardUpdateTimeouts[variantId] = setTimeout(() => {
    delete cardUpdateTimeouts[variantId];
    performCardUpdate(variantId, qty, isNew, container);
  }, 300);
}

async function performCardUpdate(variantId, qty, isNew, container) {
  const addBtn = container?.querySelector('[data-add-to-cart-simple]');
  if (addBtn && isNew) addBtn.classList.add('is-loading');

  const url = isNew ? '/cart/add.js' : '/cart/change.js';
  const body = isNew
    ? JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    : JSON.stringify({ id: variantId, quantity: qty });

  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body
    });

    if (res.ok) {
      const data = await res.json();
      
      // If it was a new add, now update the UI to show quantity selector
      if (isNew) {
        updateCardUI(container, 1);
      }

      // /cart/add.js returns { items } not { item_count } - get count from a parallel fetch
      if (isNew) {
        // Open cart immediately - don't wait for icon count
        document.dispatchEvent(new CustomEvent('cart:open'));
        if (window.showToast) window.showToast('Product added to cart!');
        // Get count async without blocking
        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            window.updateCartIcon(cart.item_count);
            // Sync all cards now
            syncAllCards(cart);
            // Mark dirty so drawer refreshes with the new item
            document.dispatchEvent(new CustomEvent('cart:updated'));
          })
          .catch(() => {});
      } else {
        // /cart/change.js returns full cart
        const cart = data;
        window.updateCartIcon(cart.item_count);

        // Verify server didn't cap our quantity
        const item = cart.items?.find(i => String(i.variant_id) === String(variantId));
        if (item && item.quantity !== qty) {
          updateCardUI(container, item.quantity);
          if (qty > item.quantity && window.showToast) {
            window.showToast(`Only ${item.quantity} items available in stock!`);
          }
        } else if (!item && !isNew) {
          updateCardUI(container, 0);
        }

        // Notify drawer to refresh its content, but only if it's open
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      }
    }
  } catch (err) {
    console.error('Card Cart Update Failed:', err);
  } finally {
    if (addBtn) addBtn.classList.remove('is-loading');
  }
}

// Sync all product cards after a cart change
function syncAllCards(cart) {
  if (!cart || !cart.items) return;
  
  document.querySelectorAll('[data-product-card]').forEach(card => {
    const pills = card.querySelectorAll('[data-variant-pill]');
    const addBtn = card.querySelector('[data-add-to-cart-simple]');
    const container = card.querySelector('[data-cart-interaction-container]');
    
    if (!addBtn || !container) return;
    
    let currentVariantId = addBtn.dataset.variantId;
    let currentQty = 0;

    pills.forEach(pill => {
      const vId = pill.dataset.variantId;
      const item = cart.items.find(i => String(i.variant_id) === String(vId));
      const qty = item ? item.quantity : 0;
      pill.dataset.cartQty = qty;
      
      if (String(vId) === String(currentVariantId)) {
        currentQty = qty;
      }
    });

    // Only update UI if we aren't currently debouncing an update for this card
    if (!cardUpdateTimeouts[currentVariantId]) {
      updateCardUI(container, currentQty);
    }
  });
}

// ─────────────────────────────────────────────
// CLICK DELEGATION HUB
// ─────────────────────────────────────────────
function initClickDelegation() {
  document.body.addEventListener('click', async (e) => {
    // Quick Add
    const quickAddBtn = e.target.closest('.quick-add-btn');
    if (quickAddBtn) {
      e.preventDefault();
      handleQuickAdd(quickAddBtn.getAttribute('data-product-handle'));
      return;
    }

    // Legacy .add-to-cart-btn
    const addToCartBtn = e.target.closest('.add-to-cart-btn');
    if (addToCartBtn) {
      e.preventDefault();
      const variantId = addToCartBtn.getAttribute('data-variant-id');
      if (variantId) {
        let quantity = 1;
        const card = addToCartBtn.closest('.group');
        if (card) {
          const qtyInput = card.querySelector('.product-qty-input');
          if (qtyInput?.value) quantity = parseInt(qtyInput.value) || 1;
        }
        handleAddToCart(variantId, quantity, addToCartBtn);
      }
      return;
    }
  });

  document.body.addEventListener('submit', async (e) => {
    const form = e.target;
    if (
      form.tagName === 'FORM' &&
      form.getAttribute('action')?.includes(window.routes?.cart_add_url || '/cart/add')
    ) {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      if (btn) { btn.classList.add('loading'); btn.disabled = true; }
      try {
        const res = await fetch((window.routes?.cart_add_url || '/cart/add') + '.js', {
          method: 'POST',
          body: new FormData(form)
        });
        if (res.ok) {
          document.dispatchEvent(new CustomEvent('cart:open'));
        } else {
          const data = await res.json();
          alert(data.description || 'Error adding to cart');
        }
      } catch (err) {
        console.error('Cart Add Failed:', err);
      } finally {
        if (btn) { btn.classList.remove('loading'); btn.disabled = false; }
      }
    }
  });
}

async function handleAddToCart(variantId, quantity, btnEl = null) {
  if (btnEl) { btnEl.classList.add('loading'); btnEl.disabled = true; }
  try {
    const res = await fetch((window.routes?.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: parseInt(quantity, 10) }] })
    });
    if (res.ok) {
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      if (window.updateCartIcon) window.updateCartIcon(cart.item_count);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      document.dispatchEvent(new CustomEvent('cart:open'));
      if (window.showToast) window.showToast('Product added to cart!');
    } else {
      const data = await res.json();
      alert(data.description || 'Error adding to cart');
    }
  } catch (error) {
    console.error('Cart Add Failed:', error);
  } finally {
    if (btnEl) { btnEl.classList.remove('loading'); btnEl.disabled = false; }
  }
}

// ─────────────────────────────────────────────
// QUICK VIEW
// ─────────────────────────────────────────────
let qvModal, qvOverlay, qvContainer, qvContent, qvClose;

function initQuickAdd() {
  qvModal = document.getElementById('quick-view-modal');
  qvOverlay = document.getElementById('quick-view-overlay');
  qvContainer = document.getElementById('quick-view-container');
  qvContent = document.getElementById('quick-view-content');
  qvClose = document.getElementById('quick-view-close');
  if (!qvModal) return;
  qvClose?.addEventListener('click', closeQuickView);
  qvOverlay?.addEventListener('click', closeQuickView);
}

function openQuickView() {
  if (!qvModal) return;
  qvModal.classList.remove('invisible');
  requestAnimationFrame(() => {
    qvOverlay.classList.remove('opacity-0');
    qvOverlay.classList.add('opacity-100');
    qvContainer.classList.add('open');
  });
  document.body.classList.add('overflow-hidden');
  document.documentElement.classList.add('overflow-hidden');
}

function closeQuickView() {
  if (!qvModal) return;
  qvOverlay.classList.remove('opacity-100');
  qvOverlay.classList.add('opacity-0');
  qvContainer.classList.remove('open');
  setTimeout(() => qvModal.classList.add('invisible'), 350);
  document.body.classList.remove('overflow-hidden');
  document.documentElement.classList.remove('overflow-hidden');
}

async function handleQuickAdd(handle) {
  if (!qvModal) { window.location.href = `/products/${handle}`; return; }
  openQuickView();
  qvContent.innerHTML = '<div class="flex-1 flex items-center justify-center p-12"><div class="animate-spin rounded-full h-12 w-12 border-4 border-gray-100 border-t-black"></div></div>';
  try {
    const res = await fetch(`/products/${handle}?section_id=quick-view`);
    if (!res.ok) throw new Error('Fetch failed');
    qvContent.innerHTML = await res.text();
    bindQuickViewEvents(handle);
  } catch (err) {
    qvContent.innerHTML = '<div class="p-12 text-center text-red-500 font-bold">Failed to load product details.</div>';
  }
}

function bindQuickViewEvents(handle) {
  const priceDisplay = document.getElementById('qv-price');
  const compareDisplay = document.getElementById('qv-compare-price');
  const addBtn = document.getElementById('qv-add-btn');
  const qtyInput = document.getElementById('qv-qty-input');
  
  let currentWeight = 0;
  const activeVariantBtn = document.querySelector('.qv-variant-btn.active-variant');
  if (activeVariantBtn) {
    currentWeight = parseInt(activeVariantBtn.getAttribute('data-weight') || 0);
  }

  function validateQty(targetQty) {
    if (currentWeight > 0) {
      const maxQty = Math.max(1, Math.floor(20000 / currentWeight));
      if (targetQty > maxQty) {
        if (window.showToast) window.showToast('Maximum 21kg allowed per order');
        return maxQty;
      }
    }
    return targetQty;
  }

  document.querySelectorAll('.qv-variant-btn').forEach(btn => {
    btn.onclick = () => {
      const id = btn.getAttribute('data-id');
      const price = parseInt(btn.getAttribute('data-price'));
      const compare = btn.getAttribute('data-compare');
      currentWeight = parseInt(btn.getAttribute('data-weight') || 0);

      document.querySelectorAll('.qv-variant-btn').forEach(b => {
        b.classList.remove('active-variant');
        b.classList.add('bg-white', 'text-[#000828]', 'border-gray-200');
      });
      btn.classList.add('active-variant');
      btn.classList.remove('bg-white', 'text-[#000828]', 'border-gray-200');

      priceDisplay.innerHTML = formatMoney(price);
      if (compareDisplay) {
        compareDisplay.innerHTML = compare ? formatMoney(parseInt(compare)) : '';
        compareDisplay.classList.toggle('hidden', !compare);
      }
      addBtn.setAttribute('data-variant-id', id);
      
      // Validate current quantity under new variant's weight rules
      qtyInput.value = validateQty(parseInt(qtyInput.value) || 1);
    };
  });

  document.querySelectorAll('.qv-qty-btn').forEach(btn => {
    btn.onclick = () => {
      const delta = parseInt(btn.getAttribute('data-delta'));
      const current = parseInt(qtyInput.value) || 1;
      const target = current + delta;
      if (target >= 1) {
        qtyInput.value = validateQty(target);
      }
    };
  });

  addBtn.onclick = async () => {
    const variantId = addBtn.getAttribute('data-variant-id');
    const qty = parseInt(qtyInput.value);
    await handleAddToCart(variantId, qty, addBtn);
    closeQuickView();
  };

  const buyBtn = document.getElementById('qv-buy-btn');
  if (buyBtn) {
    buyBtn.onclick = (e) => {
      e.preventDefault();
      const variantId = addBtn.getAttribute('data-variant-id');
      const qty = parseInt(qtyInput.value) || 1;
      
      buyBtn.disabled = true;
      buyBtn.style.opacity = '0.8';
      buyBtn.innerHTML = `
        <svg class="animate-spin h-5 w-5 text-[#FFED1B] mr-2 inline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <span>Redirecting to Checkout...</span>
      `;

      fetch('/cart/clear.js', { method: 'POST' })
        .then(() => {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty }] })
          });
        })
        .then(() => {
          const form = document.createElement('form');
          form.action = '/cart';
          form.method = 'POST';
          form.style.display = 'none';

          const btn = document.createElement('button');
          btn.type = 'submit';
          btn.name = 'checkout';
          btn.value = 'Checkout';

          form.appendChild(btn);
          document.body.appendChild(form);
          btn.click();
          document.body.removeChild(form);
        })
        .catch((err) => {
          console.error(err);
          window.location.href = `/cart/${variantId}:${qty}`;
        });
    };
  }

  function syncQuickViewLayout() {
    const imagesCol = document.querySelector('.qv-images');
    const infoCol = document.querySelector('.qv-info');
    if (!imagesCol || !infoCol) return;
    if (window.innerWidth < 768) {
      imagesCol.style.minHeight = '';
      return;
    }
    imagesCol.style.minHeight = `${infoCol.offsetHeight}px`;
  }

  syncQuickViewLayout();

  document.querySelectorAll('#qv-desc-short button, #qv-desc-full button').forEach((btn) => {
    btn.addEventListener('click', () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(syncQuickViewLayout);
      });
    });
  });

  const scrollContainer = document.getElementById('qv-image-scroll');
  const dots = document.querySelectorAll('.qv-dot');
  if (scrollContainer && dots.length > 0) {
    scrollContainer.addEventListener('scroll', () => {
      const index = Math.round(scrollContainer.scrollLeft / scrollContainer.clientWidth);
      dots.forEach((dot, i) => {
        if (i === index) { dot.classList.add('bg-black', 'w-3'); dot.classList.remove('bg-gray-300'); }
        else { dot.classList.remove('bg-black', 'w-3'); dot.classList.add('bg-gray-300'); }
      });
    });
  }

  // Swipe-down to dismiss gesture for mobile bottom sheet
  let touchStartY = 0;
  let touchEndY = 0;
  qvContainer.addEventListener('touchstart', (e) => {
    touchStartY = e.changedTouches[0].screenY;
  }, { passive: true });
  
  qvContainer.addEventListener('touchend', (e) => {
    touchEndY = e.changedTouches[0].screenY;
    if (touchEndY - touchStartY > 120) { // Swiped down more than 120px
      const scrollable = qvContainer.querySelector('#quick-view-content');
      if (scrollable && scrollable.scrollTop <= 0) {
        closeQuickView();
      }
    }
  }, { passive: true });
}

// ─────────────────────────────────────────────
// CART DRAWER — Fully optimized
// ─────────────────────────────────────────────
function initCartDrawer() {
  const openBtn = document.getElementById('cart-btn-trigger');
  const closeBtn = document.getElementById('cart-drawer-close');
  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-drawer-overlay');
  const content = document.getElementById('cart-drawer-content');

  if (!drawer) return;

  let isOpen = false;
  let _scrollY = 0;
  let refreshAbortController = null;
  let cartUpdateTimeouts = {};
  let lastUpdateId = 0;
  let pendingRefresh = false;
  let cartDirty = false; // Only refresh HTML when cart has actually changed

  function lockBodyScroll() {
    _scrollY = window.scrollY;
    document.body.style.cssText += ';overflow:hidden;position:fixed;top:-' + _scrollY + 'px;width:100%';
  }

  function unlockBodyScroll() {
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, _scrollY);
  }

  function openCart() {
    if (isOpen) return;
    isOpen = true;
    drawer.classList.remove('invisible');
    // Start animation immediately — no setTimeout/rAF delay
    overlay.classList.remove('opacity-0');
    overlay.classList.add('opacity-100');
    content.classList.remove('translate-x-full');
    content.classList.add('translate-x-0');
    lockBodyScroll();

    document.dispatchEvent(new CustomEvent('cart-drawer:open'));
    document.dispatchEvent(new CustomEvent('cart:open'));
    if (typeof window.reScanGoKwik === 'function') {
      setTimeout(window.reScanGoKwik, 50);
    }

    // Only fetch fresh HTML if cart was modified since last render
    if (cartDirty) {
      cartDirty = false;
      refreshCart();
    }
  }

  function closeCart() {
    if (!isOpen) return;
    isOpen = false;
    overlay.classList.remove('opacity-100');
    overlay.classList.add('opacity-0');
    content.classList.remove('translate-x-0');
    content.classList.add('translate-x-full');
    setTimeout(() => drawer.classList.add('invisible'), 280);
    unlockBodyScroll();
  }

  // ── Refresh drawer HTML via Section Rendering API ──
  async function refreshCart() {
    if (Object.keys(cartUpdateTimeouts).length > 0) {
      pendingRefresh = true;
      return;
    }
    pendingRefresh = false;

    if (refreshAbortController) refreshAbortController.abort();
    refreshAbortController = new AbortController();

    const itemsWrapper = document.getElementById('cart-items-container');
    const footerWrapper = document.getElementById('cart-drawer-footer');
    
    // Subtle loading state
    if (itemsWrapper) itemsWrapper.style.opacity = '0.6';
    if (footerWrapper) footerWrapper.style.opacity = '0.6';

    try {
      const res = await fetch(`${window.routes?.cart_url || '/cart'}?sections=cart-drawer`, {
        cache: 'no-store',
        signal: refreshAbortController.signal
      });
      const data = await res.json();
      if (!data['cart-drawer']) return;

      // Bail if user started a new interaction while we were fetching
      if (Object.keys(cartUpdateTimeouts).length > 0) {
        pendingRefresh = true;
        return;
      }

      const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');

      const activeKey = document.activeElement?.classList.contains('cart-qty-input')
        ? document.activeElement.getAttribute('data-key')
        : null;

      const targetItems = document.getElementById('cart-items-container');
      const newItems = html.querySelector('#cart-items-container');
      if (targetItems && newItems) {
        if (activeKey) {
          // Preserve focused input value; update the rest surgically
          html.querySelectorAll('.cart-qty-input').forEach((newInput, i) => {
            const currentInputs = targetItems.querySelectorAll('.cart-qty-input');
            const existing = currentInputs[i];
            if (existing && existing.getAttribute('data-key') !== activeKey) {
              existing.value = newInput.value;
            }
          });
          const newTotals = html.querySelectorAll('.text-right .font-signika');
          targetItems.querySelectorAll('.text-right .font-signika').forEach((p, i) => {
            if (newTotals[i]) p.textContent = newTotals[i].textContent;
          });
        } else {
          targetItems.innerHTML = newItems.innerHTML;
        }
      }

      const targetFooter = document.getElementById('cart-drawer-footer');
      const newFooter = html.querySelector('#cart-drawer-footer');
      if (targetFooter && newFooter) {
        targetFooter.innerHTML = newFooter.innerHTML;
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (typeof window.reScanGoKwik === 'function') {
          setTimeout(window.reScanGoKwik, 50);
        }
      }

      const countEl = html.querySelector('#cart-item-count');
      if (countEl) window.updateCartIcon(countEl.textContent.trim());

    } catch (e) {
      if (e.name !== 'AbortError') console.error('Cart refresh failed:', e);
    } finally {
      if (itemsWrapper) itemsWrapper.style.opacity = '1';
      if (footerWrapper) footerWrapper.style.opacity = '1';
    }
  }

  // ── Cart item quantity update inside drawer ──
  function debouncedUpdateCartItem(key, qty) {
    const id = ++lastUpdateId;
    clearTimeout(cartUpdateTimeouts[key]);
    
    // Optimistic UI for subtotal/total would be too complex here, 
    // but we show loading state on the footer during the eventual refresh.
    
    cartUpdateTimeouts[key] = setTimeout(() => {
      delete cartUpdateTimeouts[key];
      updateCartItem(key, qty, id);
    }, 400); // 400ms debounce for smoother typing
  }

  async function updateCartItem(key, qty, updateId) {
    try {
      const res = await fetch((window.routes?.cart_change_url || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      if (res.ok) {
        const cart = await res.json();
        window.updateCartIcon(cart.item_count);

        // Correct any server-capped quantities
        const item = cart.items?.find(i => String(i.key) === String(key) || String(i.variant_id) === String(key));
        if (item && item.quantity !== qty) {
          document.querySelectorAll(`input[data-key="${key}"]`).forEach(inp => inp.value = item.quantity);
          if (qty > item.quantity && window.showToast) window.showToast(`Only ${item.quantity} items available!`);
        } else if (!item && qty > 0) {
          document.querySelectorAll(`input[data-key="${key}"]`).forEach(inp => inp.value = 0);
        }

        if (updateId === lastUpdateId && Object.keys(cartUpdateTimeouts).length === 0) {
          refreshCart();
        }

        // Sync product cards on the page (Collection/Home)
        if (typeof syncAllCards === 'function') {
          syncAllCards(cart);
        }

        // Notify other components (like Product Detail page)
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      }
    } catch (e) {
      console.error('Cart update failed:', e);
    }
  }

  // ── Event delegation for drawer buttons ──
  document.body.addEventListener('click', (e) => {
    // Qty +/- buttons
    const btn = e.target.closest('.cart-qty-btn');
    if (btn) {
      e.preventDefault();
      const key = btn.getAttribute('data-key');
      if (!key) return;
      const input = document.querySelector(`.cart-qty-input[data-key="${key}"]`);
      if (!input) return;

      const isIncrease = btn.getAttribute('aria-label')?.toLowerCase().includes('increase');
      const isB2B = btn.getAttribute('data-is-b2b') === 'true';
      const weight = parseInt(btn.getAttribute('data-weight') || 0);
      
      let cur = parseInt(input.value) || 0;
      let newQty = cur;

      if (isIncrease) {
        if (isB2B) {
          if (cur < 10) {
            newQty = cur + 1;
          } else {
            if (window.showToast) window.showToast('Maximum 10 boxes allowed for B2B orders');
            return;
          }
        } else if (weight > 0) {
          const maxQty = Math.max(1, Math.floor(20000 / weight));
          if (cur < maxQty) {
            newQty = cur + 1;
          } else {
            if (window.showToast) window.showToast('Maximum 21kg allowed per order');
            return;
          }
        } else {
          newQty = cur + 1;
        }
      } else {
        newQty = Math.max(0, cur - 1);
      }
      
      input.value = newQty;

      const row = btn.closest('.group');
      if (newQty === 0) {
        if (row) {
          row.style.opacity = '0.4';
          row.style.filter = 'grayscale(1)';
        }
      } else {
        if (row) {
          row.style.opacity = '1';
          row.style.filter = 'none';
        }
      }

      cartDirty = true;
      debouncedUpdateCartItem(key, newQty);
      return;
    }

    // Remove button
    const removeBtn = e.target.closest('.cart-remove-btn');
    if (removeBtn) {
      e.preventDefault();
      const key = removeBtn.getAttribute('data-key');
      const row = removeBtn.closest('.group');
      if (row) {
        row.style.transition = 'all 300ms ease';
        row.style.opacity = '0';
        row.style.transform = 'translateX(20px)';
        setTimeout(() => { 
          row.style.maxHeight = '0'; 
          row.style.paddingTop = '0'; 
          row.style.paddingBottom = '0'; 
          row.style.marginTop = '0'; 
          row.style.marginBottom = '0'; 
        }, 100);
        setTimeout(() => row.remove(), 400);
      }
      cartDirty = true;
      updateCartItem(key, 0, ++lastUpdateId);
      return;
    }
  });

  document.body.addEventListener('input', (e) => {
    if (e.target.classList.contains('cart-qty-input')) {
      const key = e.target.getAttribute('data-key');
      const weight = parseInt(e.target.getAttribute('data-weight') || 0);
      const isB2B = e.target.getAttribute('data-is-b2b') === 'true';
      let qty = parseInt(e.target.value);
      if (!isNaN(qty)) { 
        if (isB2B) {
          if (qty > 10) {
            qty = 10;
            e.target.value = 10;
            if (window.showToast) window.showToast('Maximum 10 boxes allowed for B2B orders');
          }
        } else if (weight > 0) {
          const maxQty = Math.max(1, Math.floor(20000 / weight));
          if (qty > maxQty) {
            qty = maxQty;
            e.target.value = maxQty;
            if (window.showToast) window.showToast('Maximum 21kg allowed per order');
          }
        }
        cartDirty = true; 
        debouncedUpdateCartItem(key, Math.max(0, qty)); 
      }
    }
  });

  document.body.addEventListener('change', (e) => {
    if (e.target.classList.contains('cart-qty-input')) {
      const key = e.target.getAttribute('data-key');
      const weight = parseInt(e.target.getAttribute('data-weight') || 0);
      const isB2B = e.target.getAttribute('data-is-b2b') === 'true';
      let qty = parseInt(e.target.value);
      if (isNaN(qty) || qty < 0) {
        qty = 0;
        e.target.value = 0;
      } else {
        if (isB2B) {
          if (qty > 10) {
            qty = 10;
            e.target.value = 10;
            if (window.showToast) window.showToast('Maximum 10 boxes allowed for B2B orders');
          }
        } else if (weight > 0) {
          const maxQty = Math.max(1, Math.floor(20000 / weight));
          if (qty > maxQty) {
            qty = maxQty;
            e.target.value = maxQty;
            if (window.showToast) window.showToast('Maximum 21kg allowed per order');
          }
        }
      }
      cartDirty = true;
      updateCartItem(key, qty, ++lastUpdateId);
    }
  });

  // ── Trigger listeners ──
  openBtn?.addEventListener('click', (e) => { e.preventDefault(); openCart(); });
  closeBtn?.addEventListener('click', closeCart);
  overlay?.addEventListener('click', closeCart);
  document.addEventListener('cart:open', openCart);

  // When a card/product add completes, mark cart dirty so next open refreshes
  document.addEventListener('cart:updated', (e) => {
    cartDirty = true;
    
    // Sync all product cards with the new cart state
    if (e.detail && e.detail.items) {
      syncAllCards(e.detail);
    } else {
      fetch('/cart.js').then(r => r.json()).then(syncAllCards).catch(() => {});
    }

    if (isOpen) {
      refreshCart();
      cartDirty = false;
    }
  });

  document.addEventListener('cart:refresh', () => {
    cartDirty = true;
    if (isOpen) {
      refreshCart();
      cartDirty = false;
    }
  });
}

// ─────────────────────────────────────────────
// SEO: Fix Shopify Cookie Banner H2
// ─────────────────────────────────────────────
function fixShopifyCookieBannerSEO() {
  const processBanner = (bannerNode) => {
    bannerNode.querySelectorAll('h2').forEach(h2 => {
      if (h2.textContent.toLowerCase().includes('cookie')) {
        const div = document.createElement('div');
        div.innerHTML = h2.innerHTML;
        div.className = h2.className;
        div.style.cssText = 'font-size:1.25rem;font-weight:bold;margin:0';
        h2.parentNode.replaceChild(div, h2);
      }
    });
  };

  const existingBanner = document.getElementById('shopify-pc__banner');
  if (existingBanner) processBanner(existingBanner);

  new MutationObserver(mutations => {
    mutations.forEach(m => m.addedNodes.forEach(node => {
      if (node.nodeType !== 1) return;
      if (node.id === 'shopify-pc__banner') processBanner(node);
      else if (node.querySelector?.('#shopify-pc__banner')) processBanner(node.querySelector('#shopify-pc__banner'));
      else if (node.tagName === 'H2' && node.textContent.toLowerCase().includes('cookie')) processBanner(node.parentNode);
    }));
  }).observe(document.body, { childList: true, subtree: true });
}
